module.exports = __webpack_public_path__ + "static/icon-edu.d5b56f81.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon-edu.png
// module id = 310
// module chunks = 2